import React, { useState, useEffect } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import Checkbox from 'reusableComponents/Checkbox'
import styled from 'styled-components'
import Form from 'react-bootstrap/Form'
import PropTypes from 'prop-types'
import { breakpoints, colors } from 'globalStyles'
import { useSelector } from 'react-redux'
import { selectDeliverySummary } from 'store/shipping/shippingSelectors'
import TermsAndConditions from 'components/TermsAndConditions'
import constants from 'constants.json'
import { StyledSwitch } from 'components/MyPreferences/SignaturePreferenceToggle.style'

const SigReleaseAuth = styled.div`
  text-align: left;
  @media ${breakpoints.phone}, ${breakpoints.tablet} {
    width: 298px;
  }
  @media ${breakpoints.desktop} {
    width: 452px;
  }
  .signAuthHeader {
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
  }

  .signAuthContent {
    margin-top: 16px;
    text-align: left;

    .form-check-input[type='checkbox'] {
      width: 26px !important;
      height: 26px !important;
      margin-right: 12px;
    }

    .form-check-label {
      display: table-row;
      font-size: 14px;
      line-height: 20px;
    }
  }
`

const StyledToggleDiv = styled.div`
  margin-top: 16px;
`

const StyledSpan = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`

const StyledDiv = styled.div`
  background-color: ${colors.yellow};
  margin-top: 16px;
  padding: 12px;
  @media ${breakpoints.desktop} {
    margin-top: 24px;
    padding: 16px;
  }
  @media ${breakpoints.xs} {
    margin-right: 18px;
  }
`

const SignatureReleaseAuthorization = ({ handleClick, isSaveEnabled }) => {
  const [checkboxClicked, setcheckboxClicked] = useState(false)
  const [validated, setValidated] = useState(false)

  const { remoteSignaturePreference } = useSelector(selectDeliverySummary)

  const onCheckBoxClick = (event) => {
    setcheckboxClicked(event.target.checked)
    isSaveEnabled(true)
  }

  const defaultToggleState = remoteSignaturePreference === 'PTL'
  const [releaseWithoutSignaturePreference, setReleaseWithoutSignaturePreference] =
    useState(defaultToggleState)

  const { t, i18n } = useTranslation('translation', { keyPrefix: 'signaturePreferences' })
  const { language } = i18n
  const SIGNATURE_PREFERENCE_RELEASE_WITHOUT_SIGNATURE =
    constants.SIGNATURE_PREFERENCE.RELEASE_WITHOUT_SIGNATURE
  const SIGNATURE_PREFERENCE_SIGNATURE_REQUIRED = constants.SIGNATURE_PREFERENCE.SIGNAUTRE_REQUIRED

  useEffect(() => {
    isSaveEnabled(false)
    if (!releaseWithoutSignaturePreference && remoteSignaturePreference === 'PTL') {
      isSaveEnabled(true)
    }
  }, [releaseWithoutSignaturePreference])

  const handleChange = async () => {
    isSaveEnabled(false)
    setReleaseWithoutSignaturePreference(!releaseWithoutSignaturePreference)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    const form = event.currentTarget
    if (form.checkValidity() === false) {
      event.stopPropagation()
    }
    setValidated(true)
    if (remoteSignaturePreference === 'Regular' && checkboxClicked) {
      handleClick(
        SIGNATURE_PREFERENCE_RELEASE_WITHOUT_SIGNATURE,
        SIGNATURE_PREFERENCE_SIGNATURE_REQUIRED
      )
    } else if (remoteSignaturePreference === 'PTL') {
      handleClick(
        SIGNATURE_PREFERENCE_SIGNATURE_REQUIRED,
        SIGNATURE_PREFERENCE_RELEASE_WITHOUT_SIGNATURE
      )
    }
  }

  return (
    <SigReleaseAuth>
      <Form id="signForm" noValidate validated={validated} onSubmit={handleSubmit}>
        <div>{i18n.t(`my_preferences.waive_signature_msg`)}</div>
        <StyledToggleDiv>
          <StyledSpan>{i18n.t(`my_preferences.release_signature`)}</StyledSpan>
          <div style={{ float: 'right', marginRight: '5px' }}>
            <StyledSwitch
              language={language}
              checked={releaseWithoutSignaturePreference}
              disableRipple
              onChange={handleChange}
            />
          </div>
        </StyledToggleDiv>
        {releaseWithoutSignaturePreference && remoteSignaturePreference === 'Regular' && (
          <StyledDiv>
            <div>
              <Form.Group controlId="sigAuth">
                <span className="signAuthHeader">{t('signAuthHeader')}</span>
                <div className="signAuthContent">
                  <Checkbox
                    name="sigAuth"
                    value={checkboxClicked}
                    onChange={onCheckBoxClick}
                    label={
                      <Trans
                        t={t}
                        i18nKey="signAuthContent"
                        components={[<TermsAndConditions />]}
                      />
                    }
                    errText={t('signAuthError')}
                    isRequired
                  />
                </div>
              </Form.Group>
            </div>
          </StyledDiv>
        )}
        {!releaseWithoutSignaturePreference && remoteSignaturePreference === 'PTL' && (
          <StyledDiv>
            <div>
              <Trans t={t} i18nKey="removeSignature" components={[<TermsAndConditions />]} />
            </div>
          </StyledDiv>
        )}
      </Form>
    </SigReleaseAuth>
  )
}

SignatureReleaseAuthorization.propTypes = {
  handleClick: PropTypes.func.isRequired,
  isSaveEnabled: PropTypes.func.isRequired,
}

export default SignatureReleaseAuthorization
